



































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { GetListByCode } from "@/api/configureDictionary";
import { GetQualityControlList } from "@/api/pdQualityControlManage/pdQualityControlReminder";
@Component({})
export default class PdQualityControlReminder extends AbpBase {
  loading: boolean = false;
  QualityControlType: any[] = [];
  QualityControlList: any[] = [];
  selectComponent: any = {};
  QualityControlcolumns = [
    {
      title: "编号",
      key: "id",
      minWidth: 100
    },
    {
      title: "医保卡号",
      key: "card",
      minWidth: 160
    },
    {
      title: "姓名",
      key: "name",
      minWidth: 160
    },
    {
      title: "身份证号",
      key: "cid",
      minWidth: 200
    },
    {
      title: "检查项目",
      key: "checkItemName",
      minWidth: 200
    },
    {
      title: "最近检查时间",
      key: "checkTime",
      minWidth: 160,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.checkTime));
      }
    },
    {
      title: "计划检查时间",
      key: "planTime",
      width: 160,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.PlanTime));
      }
    },
    {
      title: "超过天数",
      key: "days",
      width: 160
    }
  ];

  async getData() {
    this.loading = true;
    var res = await GetQualityControlList(this.selectComponent);
    this.QualityControlList = res.objects;
    this.loading = false;
  }
  initDic() {
    GetListByCode({ input: "PD_Dic_QC_Type" }).then(res => {
      this.QualityControlType = res;
      this.selectComponent.type = -1;
    });
  }
  constructor() {
    super();
    this.initDic();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdQualityControlManage/pdQualityControlReminder/index.vue